import { useState, useCallback } from 'react';
import { throwErrorToast } from 'utils';
import { errorMessages } from 'constants/messages';
import { getAuthToken } from 'utils/auth';

export type AuthCheckResult = {
    status: number;
    token: string;
};

interface AuthCheckResponse {
    isError: boolean;
    isLoading: boolean;
    checkAuth: (params?: AuthCheckParams) => Promise<AuthCheckResult | null>;
}

interface AuthCheckParams {
    showErrorToast?: boolean;
}

export const useAuthCheck = (): AuthCheckResponse => {
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);

    const checkAuth = useCallback(async (params: AuthCheckParams = {}): Promise<AuthCheckResult | null> => {
        const { showErrorToast = true } = params;
        setIsLoading(true);
        setIsError(false);
        try {
            const token = await getAuthToken();

            if (!token) throw new Error(errorMessages[401]);

            setIsLoading(false);
            return { status: 202, token };
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : errorMessages[401];

            if (showErrorToast) {
                throwErrorToast({ message: errorMessage });
            }

            setIsError(true);
            setIsLoading(false);
            return null;
        }
    }, []);

    return { isError, isLoading, checkAuth };
};
